import React from 'react';
import { Checkbox, Typography } from '@mui/material';
import {
  PsdCheckboxCell,
  PsdGridRow,
  PsdPercentCell,
  PsdSizeCell,
} from 'containers/PropertyPanel/Cards/Feed/PsdGrid';
import { styled } from '@mui/material/styles';

interface PsdTableRowInterface {
  sizeValue: number | undefined;
  percentValue: number | undefined;
  index: number;
  editByCurve: boolean;
  selected: boolean;
  removeIndexes: number[];
  setRemoveIndexes(newRemoveIndexes: number[]): void;
  setEditIndex(index: number): void;
  animateSave: number;
  hidePsd: boolean;
  tabIndex?: number;
  cellTabbing: {
    selectedCell: boolean[];
    setSelectedCell: React.Dispatch<React.SetStateAction<boolean[]>>;
  };
}

const StyledPsdSizeCell = styled(PsdSizeCell)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.grey['100'],
  },
  height: 36,
  borderRadius: theme.spacing(1),
  alignContent: 'center',
}));

const StyledPsdPercentCell = styled(PsdPercentCell)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.grey['100'],
  },
  height: 36,
  borderRadius: theme.spacing(1),
  alignContent: 'center',
}));

export const PsdTableRow = ({
  cellTabbing,
  sizeValue,
  percentValue,
  index,
  editByCurve,
  selected,
  removeIndexes,
  setRemoveIndexes,
  setEditIndex,
  animateSave,
  hidePsd,
}: PsdTableRowInterface) => {
  const nbrCells = !hidePsd ? 2 : 1;

  const handleSelect = (cellIndex: number) => {
    const tmpArray = new Array(nbrCells).fill(false);

    tmpArray[cellIndex] = true;
    setEditIndex(index);
    cellTabbing.setSelectedCell(tmpArray);
  };

  return (
    <PsdGridRow
      animate={index === animateSave ? 1 : 0}
      status={editByCurve ? 'highlight' : 'default'}
    >
      <PsdCheckboxCell>
        <Checkbox
          size='small'
          checked={selected}
          onChange={() => {
            const indexExist = removeIndexes?.findIndex((i) => i === index);
            const modifiedIndexes = [...removeIndexes];
            if (indexExist === -1) {
              modifiedIndexes.push(index);
            } else {
              modifiedIndexes.splice(indexExist, 1);
            }
            setRemoveIndexes(modifiedIndexes);
          }}
          color='info'
          tabIndex={-1}
        />
      </PsdCheckboxCell>

      <StyledPsdSizeCell onClick={() => handleSelect(0)}>
        <Typography variant={'body2'}>{sizeValue}</Typography>
      </StyledPsdSizeCell>

      {!hidePsd && (
        <StyledPsdPercentCell onClick={() => handleSelect(1)}>
          <Typography variant={'body2'}>{percentValue}</Typography>
        </StyledPsdPercentCell>
      )}
    </PsdGridRow>
  );
};
